import { RootStore } from '~store/RootStore';

class GeneralStore {
  constructor(private readonly rootStore: RootStore) {
    this.rootStore = rootStore;
  }
}

export default GeneralStore;
